import { OFFERS_ROUTER } from '~/constants/router';
import { useRecentlyViewedProducts } from '~/domains/products/queries';
import { useLinkComponent } from '~/hooks/mobileApp';

import DisplayProducts from './DisplayProducts';

import { MoreIcon } from '~/assets/icons';

export function RecentlyViewedSimilarProductList() {
  const products = useRecentlyViewedProducts();
  const LinkComponent = useLinkComponent();

  if (!products?.length) {
    return null;
  }

  return (
    <div>
      <div className="mb-16 flex items-center justify-between px-20">
        <h2 className="text-paragraph typo-caption100-semibold">
          최근 본 상품의 연관상품
        </h2>
        <LinkComponent
          href={OFFERS_ROUTER.recentlyViewed}
          className="ml-8 shrink-0"
        >
          <span className="flex items-center text-blue-800 typo-paragraph100-regular">
            전체보기
            <MoreIcon />
          </span>
        </LinkComponent>
      </div>
      <DisplayProducts products={products} />
    </div>
  );
}
